
/*export const oidcConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_RUwAtccsW",
  client_id: "43n6djl1go1l9c2c9lqcribc3q",
  redirect_uri: "https://myconnect-uatbot.rrd.com/home",
  logout_uri :"https://myconnect-uatbot.rrd.com/signout",
  //post_logout_redirect_uri: "https://myconnect-uatbot.rrd.com/signout",
  response_type: "code",
  scope: "email openid phone profile",
  cdomain : "https://rrd-ea-demo.auth.us-east-1.amazoncognito.com",
  extraQueryParams: {
    identity_provider: "RRD-SSO",
    prompt : "login"
  },
};*/ 

/* Production Config */

/*export const oidcConfig = {
  authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_f7KA116NK",
  client_id: "7v4teqjqderi9ehtemfcrptcso",
  redirect_uri: "https://myconnect-pagesapi.rrd.com/home",
  logout_uri :"https://myconnect-pagesapi.rrd.com/signout",
  //post_logout_redirect_uri: "https://myconnect-uatbot.rrd.com/signout",
  response_type: "code",
  scope: "email openid phone profile",
  cdomain : "https://rrd-ea-demo.auth.us-east-1.amazoncognito.com",
  extraQueryParams: {
    identity_provider: "RRD-SSO",
    prompt : "login"
  },
};*/


export const oidcConfig = {
  authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_f7KA116NK",
  client_id: "7v4teqjqderi9ehtemfcrptcso",
  redirect_uri: "https://coreweb-hrms.rrd.com/home",
  logout_uri :"https://coreweb-hrms.rrd.com/signout",
  //post_logout_redirect_uri: "https://myconnect-uatbot.rrd.com/signout",
  response_type: "code",
  scope: "email openid phone profile",
  cdomain : "https://us-east-2f7ka116nk.auth.us-east-2.amazoncognito.com",
  extraQueryParams: {
    identity_provider: "RRD-SSO",
    prompt : "login"
  },
};

/* Production Config */

/*export const oidcConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_RUwAtccsW",
  client_id: "1enk1s6o6kh673ormce375pbat",
  redirect_uri: "https://rrdhub-uat.rrd.com/home",
  logout_uri :"https://rrdhub-uat.rrd.com/SignOut",
  //post_logout_redirect_uri: "https://myconnect-uatbot.rrd.com/signout",
  response_type: "code",
  scope: "email openid phone profile",
  extraQueryParams: {
    identity_provider: "RRD-SSO",
    prompt : "login"
  },
};*/